<template>
  <vs-dropdown-item
    class="menu-accion"
    v-if="desplegar()"
    v-on:click.native="ejecutarAccion"
  >
    <div class="icono">
      <vs-icon :icon="icono" size="small"></vs-icon>
    </div>
    <div class="accion">
      {{ nombre }}
    </div>
  </vs-dropdown-item>
</template>

<script>
import PermisoAccionMixin from '../../mixins/PermisoAccionMixin';
import modalStore from '../../../../../store/modals/acciones';

import { cancelDocument } from '@/febos/servicios/api/aduanas/documents.api';

export default {
  name: 'AccionAnularGuia',
  mixins: [PermisoAccionMixin],
  props: [
    'documento',
    'handleList'
  ],
  data() {
    return {
      icono: 'cancel_presentation',
      nombre: 'Anular Documento',
      permiso: 'DTE41'
    };
  },
  methods: {
    async cancelDocument() {
      await cancelDocument({ documentId: this.documento.febosId });
      await this.handleList();
    },
    ejecutarAccion() {
      console.log('EJECUTANDO ANULAR DOCUMENTO ', this.documento);
      const modalComponente = () => import('@/febos/chile/dte/componentes/acciones/modales/modalAnularDocumento.vue');
      modalStore.commit('setTitulo', 'Anular Documento');
      modalStore.commit('mostrarBitacora', modalComponente);
      modalStore.commit('setData', this.documento);
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas anular el documento Nº ${this.documento.folio}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.cancelDocument()
      });
    },
    desplegar() {
      // eslint-disable-next-line no-underscore-dangle
      return this.esAccionAplicable() && this._tienePermiso(this.permiso);
    },
    esAccionAplicable() {
      return this.documento.tieneNc === 'no';
    }
  }

};
</script>

<style scoped>
.menu-accion {
  vertical-align: middle;
  width: 50% ;
}
.icono,
.accion {
  vertical-align: top;
  display: inline-flex;
}
.menu-accion .icono {
  margin-right: 5px;
}
</style>
